<template>
  <div>
    <div>
      <el-table
        :data="page.list"
        stripe
        style="width: 100%">
        <el-table-column
          prop="house_id"
          label="id"
          width="100">
        </el-table-column>
        <el-table-column
          prop="ancestor_name"
          label="房产" width="250">
        </el-table-column>
        <el-table-column
          prop="name"
          label="业主（户主）" width="120">
        </el-table-column>
        <el-table-column
          prop="longitude"
          label="经纬度" width="90">
          <template slot-scope="scope">
            <el-popover
              placement="right"
              trigger="hover">
              <template slot="default">
                <el-alert
                  v-if="(scope.row.latitude&&scope.row.longitude)"
                  title="房产地址定位"
                  type="success"
                  effect="dark">
                  <div>维度：{{scope.row.latitude}}</div>
                  <div>经度：{{scope.row.longitude}}</div>
                  <div>
                    地址：{{scope.row.loacl_address}}
                    <el-button v-if="!scope.row.loacl_address" @click="getLoaclAddress(scope.row)" size="mini" type="text">获取地址</el-button>
                  </div>
                </el-alert>

                <el-alert
                  v-if="!(scope.row.latitude&&scope.row.longitude)"
                  title="请先完成管家端绑定！"
                  type="warning"
                  effect="dark">
                </el-alert>
              </template>
              <i @click="openMap(scope.row)" :style="{color:((scope.row.latitude&&scope.row.longitude)?'#42a936':'#FF9900')}" style="font-size: 23px;" slot="reference" class="el-icon-location"></i>
            </el-popover>

          </template>
        </el-table-column>
        <el-table-column
          prop="yard"
          label="二维码" width="100">
          <template slot-scope="scope">
            <el-popover
              placement="right"
              trigger="hover">
              <template slot="default">
                <el-alert
                  v-if="scope.row.yard"
                  title="管家中心“一户一码”扫码"
                  type="success"
                  effect="dark">
                  <QrCode v-if="scope.row.yard" :content="scope.row.yard" height="150" width="150" />
                </el-alert>

                <el-alert
                  v-if="!scope.row.yard"
                  title="企业微信“扫一扫”扫码"
                  type="warning"
                  effect="dark">
                  <QrCode v-if="!scope.row.yard" :content="'http://butler.51homemoney.com/house-code/index?gcode='+(( scope.row.id_card?scope.row.id_card.replace(/\t/g,''):'' )||scope.row.phone||Date.now())+'&project_id='+scope.row.project_house_id" height="150" width="150" />
                </el-alert>
              </template>
              <el-button :type="scope.row.yard?'success':'warning'" size="mini" slot="reference">二维码</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="(page.p*1)"
        :page-size="page.size"
        :total="page.total"
        @current-change="getData(id,$event)"
      >
      </el-pagination>
    </div>
    <el-dialog title="地理位置" width="550px" :visible.sync="dialogTableVisible">
      <el-amap
        @AmapManager="AmapManager"
        v-if="dialogTableVisible"
        :center="center"
        class="amap-box"
        :vid="'amap-vue'"
        :zoom="17"
        :zooms="[4,22]"
        ref="amapManager"
        width="500px"
      >
        <el-amap-marker vid="component-marker" :position="center" ></el-amap-marker>
      </el-amap>
    </el-dialog>
  </div>
</template>

<script>
import QrCode from "../Common/QrCode";
export default {
  name: "HouseCodeTable",
  components: {QrCode},
  data(){
    return{
      page:{
        list:[],
        p:0,
        size:0,
        total:0
      },
      fm_where:{},
      dialogTableVisible:false,
      center:[0,0],
    }
  },
  props:{
    id:{
      type:Number,
      default(){
        return 0
      }
    },
    where:{
      type:Object,
      default() {
        return {};
      }
    }
  },
  mounted() {

  },
  methods:{
    getData(id,p=1){
      var that=this;
      let where=JSON.parse(JSON.stringify(that.where))
      console.log(where)
      // where.status&&(where.status=where.status.join(','))
      // where.apply_time&&(where.apply_time=where.apply_time.join(','))
      // where.furnish_time&&(where.furnish_time=where.furnish_time.join(','))
      ERP.getRequest({url:"admin/HouseCode/getHouseCodeList",data:{
          id:id,
          p:p,
          ...where
        }},ret=>{
        if(ret.code){
          console.log(ret.data)
          that.page=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setData(){
      var that=this;
      // ERP.postRequest({url:"admin/CustomerManagement/setCheckin",data:that.form},ret=>{
      //   if(ret.code){
      //     this.$msgbox.alert(ret.msg||"修改成功")
      //   }else{
      //     this.$msgbox.alert(ret.msg||"修改失败")
      //   }
      // })
    },
    edtiClik(data){
      this.$emit('edtiClik',data.id)
    },
    cardIntoClik(data){
      // console.log(data)
      this.$emit('onTable',{evt:'cardInto',data:data})
    },
    inspectionClik(data){
      // console.log(data)
      this.$emit('onTable',{evt:'inspection',data:data})
    },
    approvalClik(data){
      // console.log(data)
      this.$emit('onTable',{evt:'approval',data:data})
    },
    handleCommand(cmd){
      this.$emit('onTable',{evt:cmd.name,data:cmd.data})
    },
    getLoaclAddress(item){
      console.log(item);
      ERP.getRequest({url:"admin/HouseCode/getLocationPostion",data:{
          lat:item.latitude,
          lng:item.longitude
        }},ret=>{
        if(ret.code){
          item.loacl_address=(ret.data.regeocode||{}).formatted_address||'';
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    AmapManager(e){
      console.log("AmapManager",e)
    },
    openMap(item){
      console.log(item)
      var that=this;
      if(item.longitude&&item.latitude){
        that.dialogTableVisible=true;
        that.center=[item.longitude,item.latitude];
      }else {
        that.$Message.error("请先绑定");
      }

    },
  },
  watch:{
    id(n,o){
      if(n){
        this.getData(n,1);
      }
    },
    where:{
      handler(n){
        this.fm_where=n
      },
      deep:true
    }
  }

}
</script>

<style lang="scss" scoped>
//@import url(common.scss);
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  /*font-size: 12px;*/
}
.amap-box{
  width: 500px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/HouseCodeTable.vue